export const OthersIconComponent = ({
  size = 32,
  fillColor = '#FFFFFF00',
  strokeColor = '#454545',
  strokeWidth = 1.5,
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="32" height="32" rx="16" fill={fillColor} />
    <path d="M17.334 10V12.6667C17.334 12.8435 17.4042 13.013 17.5292 13.1381C17.6543 13.2631 17.8238 13.3333 18.0007 13.3333H20.6673M17.334 10H12.6673C12.3137 10 11.9746 10.1405 11.7245 10.3905C11.4745 10.6406 11.334 10.9797 11.334 11.3333V20.6667C11.334 21.0203 11.4745 21.3594 11.7245 21.6095C11.9746 21.8595 12.3137 22 12.6673 22H19.334C19.6876 22 20.0267 21.8595 20.2768 21.6095C20.5268 21.3594 20.6673 21.0203 20.6673 20.6667V13.3333M17.334 10L20.6673 13.3333M14.0007 19.3333H18.0007M14.0007 16.6667H18.0007" stroke={strokeColor} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
